import React from "react";

import TowerObservationTypeFormPageContainer from "./TowerObservationTypeFormPageContainer";

export class TowerObservationTypeFormPage extends React.Component {
  render() {
    return <TowerObservationTypeFormPageContainer {...this.props} />;
  }
}
